import { CardEvent } from 'src/store/events/types';
export const formatString = (str: string): string => {
  return encodeURI(str.toLowerCase());
};

export const getSectionString = (event: CardEvent) => {
  if (event.section) {
    return formatString(event.section.title);
  }
  return undefined;
};

export const arrayUnique = (array: any) => {
  const a = array.concat();
  for (let i = 0; i < a.length; ++i) {
    for (let j = i + 1; j < a.length; ++j) {
      if (a[i] === a[j]) {
        a.splice(j--, 1);
      }
    }
  }

  return a;
};



// WEBPACK FOOTER //
// ./src/utils/sharedHelpers.ts